export const Config = {
  baseURL: 'https://europe-west2-euro-intelligence.cloudfunctions.net/userLogin',
  endPoint: {
    //users
    login: 'https://europe-west2-euro-intelligence.cloudfunctions.net/userLogin',
    signup: 'https://europe-west2-euro-intelligence.cloudfunctions.net/userSignup',
    resetPasswordRequest:
      'https://europe-west2-euro-intelligence.cloudfunctions.net/resetPasswordRequest',
    resetPassword:
      'https://europe-west2-euro-intelligence.cloudfunctions.net/ResetPassword',
    getUserProfile: 'https://europe-west2-euro-intelligence.cloudfunctions.net/getUserData',
    updatePassword: 'https://europe-west2-euro-intelligence.cloudfunctions.net/updatePassword',
    getStories: 'https://getstories-gmksqr4hcq-uc.a.run.app',
    getStoriesByBriefingId:
      'https://europe-west2-euro-intelligence.cloudfunctions.net/getStoriesByBriefingId',
    getStoryDetails:
      'https://europe-west2-euro-intelligence.cloudfunctions.net/getStoryDetails?storyId={storyId}',
    // europe-west2 (co-located with the database) since 2026-07-19
    featchHome:
      'https://europe-west2-euro-intelligence.cloudfunctions.net/getHomeContent?page={page}&limit=5',
    podcasts: 'https://europe-west2-euro-intelligence.cloudfunctions.net/getPodcastList',
    columns: 'https://europe-west2-euro-intelligence.cloudfunctions.net/getColumnsData',
    columnById: 'https://europe-west2-euro-intelligence.cloudfunctions.net/getColumnById',

    //admin apis
    //briefing
    createBriefing: 'https://europe-west2-euro-intelligence.cloudfunctions.net/createBriefing',
    getBriefings: 'https://europe-west2-euro-intelligence.cloudfunctions.net/getBriefings',
    updateBriefing: 'https://updatebriefingstatus-gmksqr4hcq-uc.a.run.app',
    deleteBriefing: 'https://europe-west2-euro-intelligence.cloudfunctions.net/deleteBriefing',
    editBriefing: 'https://europe-west2-euro-intelligence.cloudfunctions.net/editBriefing',
    publishBriefing: 'https://europe-west2-euro-intelligence.cloudfunctions.net/publishBriefing',
    //stories
    getUserStories: 'https://europe-west2-euro-intelligence.cloudfunctions.net/getUserStories',
    createStory: 'https://europe-west2-euro-intelligence.cloudfunctions.net/createStory',
    editStory: 'https://europe-west2-euro-intelligence.cloudfunctions.net/editStory',
    deleteStory: 'https://europe-west2-euro-intelligence.cloudfunctions.net/deleteStory',
    getApprovedRejectStories:
      'https://europe-west2-euro-intelligence.cloudfunctions.net/getStoriesApprovedOrRejectedByApprover',
    getUserInDevsStories:
      'https://europe-west2-euro-intelligence.cloudfunctions.net/getUsersInDevStories',
    updateStoryStatus: 'https://europe-west2-euro-intelligence.cloudfunctions.net/updateStoryStatus',
    getGuestAuthors: 'https://europe-west2-euro-intelligence.cloudfunctions.net/getGuestAuthors',
    updateStoryPresence:
      'https://europe-west2-euro-intelligence.cloudfunctions.net/updateStoryPresence',

    //subscription
    getSubscriptionPlans:
      'https://europe-west2-euro-intelligence.cloudfunctions.net/getAllSubscriptionPlans',
    createPaymentForPlan:
      'https://europe-west2-euro-intelligence.cloudfunctions.net/createPaymentForPlan',

    // CMS
    getCustomers:
      'https://getallcustomers-gmksqr4hcq-uc.a.run.app?status={status}&page={page}&limit=20',
    getUsers:
      'https://getallusers-gmksqr4hcq-uc.a.run.app?page={page}&limit=20',
    getSubscriptions:
      'https://getallsubscriptionplanusers-gmksqr4hcq-uc.a.run.app/?page={page}&limit=20',
    createCustomer: 'https://createcustomer-gmksqr4hcq-uc.a.run.app',
    editCustomer: 'https://editcustomer-gmksqr4hcq-uc.a.run.app',
    deactivateCustomer:
      'https://us-central1-euro-intelligence.cloudfunctions.net/markCustomerInactive',

    getCustomersById:
      'https://getcustomerbyid-gmksqr4hcq-uc.a.run.app/?customerId={customerID}',
    getUsersByCustomerId:
      'https://getallusersbycustomerid-gmksqr4hcq-uc.a.run.app?customerId={customerID}',
    removeUserfromPlan:
      'https://removeusertosubscriptionplan-gmksqr4hcq-uc.a.run.app',
    //search APIs
    searchUserByName:
      'https://us-central1-euro-intelligence.cloudfunctions.net/searchUserByName?name={name}',
    searchCustomerByName:
      'https://us-central1-euro-intelligence.cloudfunctions.net/searchCustomerByName?customerName={name}',
    uploadPodcast:
      'https://us-central1-euro-intelligence.cloudfunctions.net/savePodcast',
    uploadFileS3Presign:
      'https://us-central1-euro-intelligence.cloudfunctions.net/uploadFileS3/presign',
    sendEmail:
      'https://us-central1-euro-intelligence.cloudfunctions.net/sendEmailApi',
    sendEmailToUsers:
      'https://us-central1-euro-intelligence.cloudfunctions.net/sendEmailToUser',
    getEmailDeliveryReport:
      'https://europe-west2-euro-intelligence.cloudfunctions.net/getEmailDeliveryReport',
    getArchiveExport:
      'https://europe-west2-euro-intelligence.cloudfunctions.net/getArchiveExport',
    attachUserToCustomer:
      'https://europe-west2-euro-intelligence.cloudfunctions.net/attachUserToCustomer',
    deleteUserAccount:
      'https://europe-west2-euro-intelligence.cloudfunctions.net/deleteUserAccount',
    searchStories:
      'https://us-central1-euro-intelligence.cloudfunctions.net/searchStories',
  },
};
